import axios from "~/plugins/axios";

export default {
  feed(withSmsNotification = false) {
    let url = "/ebsn/api/news/news-feed";
    let params = {
      with_sms_notification: withSmsNotification
    };
    return axios
      .get(url, { params: params })
      .then(response => response.data.data.news)
      .catch(err => err);
  },
  list(
    onlyActive,
    page = 1,
    pageSize = 24,
    fromDate,
    toDate,
    withMail = false,
    withSmsNotification = false
  ) {
    let url = "/ebsn/api/news/list";
    let params = {
      page: page,
      page_size: pageSize,
      from_date: fromDate,
      to_date: toDate,
      only_active: onlyActive,
      with_mail: withMail,
      with_sms_notification: withSmsNotification
    };
    return axios
      .get(url, { params: params })
      .then(response => response.data.data.news)
      .catch(err => err);
  },
  markAsRead(newsIds) {
    let url = "/ebsn/api/news/read";

    return axios
      .post(url, null, { params: { news_id: newsIds } })
      .then(response => response.data.data.news)
      .catch(err => err);
  },
  cancel(newsIds) {
    let url = "/ebsn/api/news/cancel";

    return axios
      .get(url, { params: { news_id: newsIds } })
      .then(response => response.data.data.news)
      .catch(err => err);
  },
  readMessage(messageId) {
    let url = "/ebsn/api/news/read_message";

    return axios
      .post(url, null, { params: { message_id: messageId } })
      .then(response => response.data.data.news)
      .catch(err => err);
  },
  cancelMessage(messageId) {
    let url = "/ebsn/api/news/cancel_message";
    let params = {
      message_id: messageId
    };
    return axios
      .get(url, { params: params })
      .then(response => response.data.data.news)
      .catch(err => err);
  }
};
